import { saveHotelSearchDraft } from '@utils/hotel-cart-adapter'

export const state = {
  lastDraft: null,
}

export const mutations = {
  SET_LAST_DRAFT(state, payload) {
    state.lastDraft = payload
  },
}

export const actions = {
  /**
   * 儲存住宿查詢選擇草稿（localStorage），供登入後或日後加車銜接。
   */
  persistDraft({ commit }, draft) {
    saveHotelSearchDraft(draft)
    commit('SET_LAST_DRAFT', draft)
  },
}
